export const LANDING_PAGE_CHIPLO_CONFIG_NAME = 'landing-chiplo';
export const PAGE_NODOS_FORM_NAME = 'nodos-form-chiplo';
